import { AxiosResponse, CancelTokenSource } from 'axios';
import { parseISO } from 'date-fns';
import API from './index';

const api = new API();

type UserCustomerModelRaw = Omit<UserCustomerModel, 'created' | 'updated'> & {
  created: string;
  updated: string | null;
};

export const getUserCustomer: (
  idToken: string,
  cancelToken: CancelTokenSource,
) => Promise<UserCustomerModel | null> = (idToken, cancelToken) =>
  (
    api._get(`/web/usercustomer`, {
      cancelToken: cancelToken.token,
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }) as Promise<AxiosResponse<UserCustomerModelRaw | null>>
  )
    .then((res) => {
      if (res.status === 200 && res.data) {
        return {
          ...res.data,
          created: parseISO(res.data.created),
          updated: res.data.updated ? parseISO(res.data.updated) : null,
        };
      }
      return null;
    })
    .catch(() => null);

export type UnsubscribeRequestModel = {
  token: string;
  allowDineoutEmails: boolean;
  allowDineoutSMSMarketing: boolean;
  allowRestaurantEmails: boolean;
  allowRestaurantSMSMarketing:boolean;
};

export type UnsubscribeFormData = {
    allowDineoutEmails: boolean;
    allowDineoutSMSMarketing: boolean;
    allowRestaurantEmails: boolean;
    allowRestaurantSMSMarketing:boolean;
    companyName: string;
};

export const updateUnsubscriptionStatus = (
  unsubscribeRequest: UnsubscribeRequestModel,
  cancelToken: CancelTokenSource,
): Promise<boolean> =>
  (
    api._post(`/web/usercustomer/unsubscribeStatus`, unsubscribeRequest, {
      cancelToken: cancelToken.token,
    }) as Promise<AxiosResponse<boolean>>
  )
    .then((res) => res.status === 200 && res.data)
    .catch(() => false);

export const getUnsubscribeFormData = (
    token: string,
    cancelToken: CancelTokenSource,
): Promise<UnsubscribeFormData | null> =>
    (
        api._get(`/web/usercustomer/unsubscribeStatus`, {
            params: { token },
            cancelToken: cancelToken.token,
        }) as Promise<AxiosResponse<UnsubscribeFormData>>
    )
        .then((res) => (res.status === 200 ? res.data : null))
        .catch(() => null);